import { z } from 'zod';

export const candidatesChatCommentsSchema = z.object({
  body: z.string().min(1),
});

export type CandidatesChatCommentsSchema = z.infer<typeof candidatesChatCommentsSchema>;
